import { createApp } from 'vue';
import PptxToPdfConverter from '@/Components/PptxToPdfConverter.vue';
import '@styles/app.css';

createApp(PptxToPdfConverter).mount('#pptx-to-pdf-converter');
